export default {
  vehicles: state => state.vehicles,
  vehicle: state => state.vehicle,
  adasIds: state => state.adasIds,
  adas: state => state.adas
}



// WEBPACK FOOTER //
// ./src/store/modules/vehicles/getters.js